export default "__VITE_ASSET__BUuZUCnl__"